import { render } from "./FunctionalitiesSection.vue?vue&type=template&id=14dafdfe&scoped=true"
const script = {}

import "./FunctionalitiesSection.vue?vue&type=style&index=0&id=14dafdfe&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14dafdfe"]])

export default __exports__